import React from 'react';
import Reflux from 'reflux';
import i18 from '../../i18';

class HeaderSteps extends Reflux.Component {

    setStep = (step) => {
        this.props.setStep(step);
    };

    renderStep = (step, label, isClickable = true) => {
        const {currentStep} = this.props;
        const isVisited = currentStep >= step;
        const className = isVisited ? 'visited' : '';

        return (
            <li
                key={step}
                className={className}
                onClick={
                    isClickable
                        ? () => this.setStep(step)
                        : undefined
                }
            >
                <button
                    type="button"
                    className={className}
                    disabled={!isClickable}
                >
                    {step}. {label}
                </button>
            </li>
        );
    };

    render() {
        return (
            <div className="steps-container">
                <div className="container">
                    <div className="row" style={{
                        
                    }}>
                        <ul className="breadcrumb">
                            {this.renderStep(1, i18.STEPS._upload)}
                            {this.renderStep(2, i18.STEPS._accountAssignment)}
                            {this.renderStep(3, i18.STEPS._download, false,)}
                        </ul>

                    </div>
                </div>
            </div>
        );
    }
}

export default HeaderSteps;


// WEBPACK FOOTER //
// ./src/components/supplier/HeaderSteps.js